import { serverEventAction } from "data/actions";
import { put, takeEvery } from "redux-saga/effects";
import { eventChannel } from "redux-saga";
import { NotificationAction } from "hooks/PostMessage/Actions";

export default function* forwardedNotificationsSaga() {
    const messageChannel = eventChannel((emitter) => {
        window.addEventListener("message", emitter);
        return /*istanbul ignore next*/ () =>
            window.removeEventListener("message", emitter);
    });

    yield takeEvery(messageChannel, messageHandler);
}

function* messageHandler(e) {
    if (!e || !e.isTrusted || e.data == null || !e.data.data) return;

    if (e.data?.source !== "inPoint") return;

    if (e.data.type !== NotificationAction.Post) return;

    yield put(serverEventAction(e.data.data));
}
